module.exports = __webpack_public_path__ + "static/media/safe_smart_3.a0e8cd91.png";